import React, {  useEffect, useState } from "react";
import { loadCourseParticipants, loadCourses } from "../utils/Network";
import ContestCitiesBarChart from "../components/charts/ContestCitiesBarChart";

import { getAge, getDefaultName, userAvatar } from "../utils";

export default function ContestStatisticsContent() {
  const [course, setCourse] = useState(null);
  const [courseParticipants, setcourseParticipants] = useState(null);
  const [cities_info, setCitiesInfo] = useState(null);
  const [living_cities_info, setLivingCitiesInfo] = useState(null);
  const [loading, setLoading] = useState(null);
  
  useEffect(() => {
    loadCourses().then((courses) => {
      if (courses.length > 0) {
        setCourse(courses[0]);
        loadCourseParticipants(courses[0].id, 1, 100000).then((data) => {
          setLoading(false);
          if (data && data.results) {
            var sorted = sortCourseParticipants(data.results);
            setcourseParticipants(sorted);
            countCities(sorted)
          }
        });
      }
    });
  }, []);

  const sortCourseParticipants = (array) => {
    return array.sort(function (a, b) {
      var x = a.usertalent.user.profile.city?.names[0]?.name;
      var y = b.usertalent.user.profile.city?.names[0]?.name;
      return x < y ? -1 : x > y ? 1 : 0;
    });
  };

  const countCities = (data) => {
     var result = {}
     var result_living = {}
     data.forEach(function (item) {
        var city = getDefaultName(item.usertalent.user.profile.city?.names);
        var city_id = item.usertalent.user.profile.city?.id;
        if(!city) city = "Unknown"

        var living_city = getDefaultName(item.usertalent.user.profile.livingcity?.names);
        var living_city_id = item.usertalent.user.profile.livingcity?.id;
        if(!living_city) living_city = "Unknown"

        if(!result[city]){ 
            var res = { 
                name : city,
                total : data.filter(obj => obj.usertalent.user.profile.city?.id == city_id ).length,
                male : data.filter(obj => obj.usertalent.user.profile.city?.id == city_id && obj.usertalent.user.profile.gender==0).length,
                female : data.filter(obj => obj.usertalent.user.profile.city?.id == city_id && obj.usertalent.user.profile.gender==1).length,
                other : data.filter(obj => obj.usertalent.user.profile.city?.id == city_id && (obj.usertalent.user.profile.gender==2) ).length,
            }
            result[city] = res
        }

        if(!result_living[living_city]){ 
          var res1 = { 
              name : living_city,
              total : data.filter(obj => obj.usertalent.user.profile.livingcity?.id == living_city_id ).length,
              male : data.filter(obj => obj.usertalent.user.profile.livingcity?.id == living_city_id && obj.usertalent.user.profile.gender==0).length,
              female : data.filter(obj => obj.usertalent.user.profile.livingcity?.id == living_city_id && obj.usertalent.user.profile.gender==1).length,
              other : data.filter(obj => obj.usertalent.user.profile.livingcity?.id == living_city_id && (obj.usertalent.user.profile.gender==2) ).length,
          }
          result_living[living_city] = res1
      }

    });

    const sortable = Object.entries(result)
    .sort(([,a],[,b]) => b.total-a.total)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  
   setCitiesInfo(sortable)

   const sortable1 = Object.entries(result_living)
    .sort(([,a],[,b]) => b.total-a.total)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  
   setLivingCitiesInfo(sortable1)

  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header">
          <h1 className="hide-on-small mb-10">&nbsp;</h1>
          <ol className="breadcrumb">
            <li>
              <a href="dashboard">
                <i className="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li>
              <a href="courses">contests</a>
            </li>
            <li className="active">View</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
          <div className="col-md-6">
              <div className="box box-primary">
                <div className="box-header with-border">
                  <h3 className="box-title">{course && getDefaultName(course.names)} <small className="font-color-orange">({courseParticipants && courseParticipants.length} participants)</small></h3>
                </div>
                <div className="box-body no-padding ">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th style={{ width: 20 }}></th>
                        <th style={{ width: 200 }}>City</th>
                        <th >Total</th>
                        <th className="hide-on-small">Male</th>
                        <th className="hide-on-small">Female</th>
                        <th className="hide-on-small">Other</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cities_info &&
                        Object.keys(cities_info).map((key,index) => (
                          <tr key={cities_info[key].name} className={loading && "loading"}>
                            <td >{index+1}</td>
                            <td className=""><b>{cities_info[key].name}</b></td>
                            <td>{cities_info[key].total}</td>
                            <td className="hide-on-small">{cities_info[key].male}</td>
                            <td className="hide-on-small">{cities_info[key].female}</td>
                            <td className="hide-on-small">{cities_info[key].other}</td>

                          </tr>
                        ))}
                    </tbody>
                    <tfoot>
                     <tr>
                            <th></th>
                            <th style={{ width: 200 }}>City</th>
                            <th >Total</th>
                            <th className="hide-on-small">Male</th>
                            <th className="hide-on-small">Female</th>
                            <th className="hide-on-small">Other</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          <div className="col-md-6">
              <div className="box box-primary">
                <div className="box-header with-border">
                  <h3 className="box-title">{course && getDefaultName(course.names)} <small className="font-color-orange">Living cities</small></h3>
                </div>
                <div className="box-body no-padding ">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th style={{ width: 20 }}></th>
                        <th style={{ width: 200 }}>City</th>
                        <th >Total</th>
                        <th className="hide-on-small">Male</th>
                        <th className="hide-on-small">Female</th>
                        <th className="hide-on-small">Other</th>
                      </tr>
                    </thead>
                    <tbody>
                      {living_cities_info &&
                        Object.keys(living_cities_info).map((key,index) => (
                          <tr key={living_cities_info[key].name} className={loading && "loading"}>
                            <td >{index+1}</td>
                            <td className=""><b>{living_cities_info[key].name}</b></td>
                            <td>{living_cities_info[key].total}</td>
                            <td className="hide-on-small">{living_cities_info[key].male}</td>
                            <td className="hide-on-small">{living_cities_info[key].female}</td>
                            <td className="hide-on-small">{living_cities_info[key].other}</td>

                          </tr>
                        ))}
                    </tbody>
                    <tfoot>
                     <tr>
                            <th ></th>
                            <th style={{ width: 200 }}>City</th>
                            <th >Total</th>
                            <th className="hide-on-small">Male</th>
                            <th className="hide-on-small">Female</th>
                            <th className="hide-on-small">Other</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          
          
          </div>
        </section>
      </div>
    </>
  );
}
